import styles from "./index.mobile.module.scss";

const LinkClient = ({ children, href, onTouchCard }) => {
  if (onTouchCard) {
    return (
      <div className={styles.jobCardLink} onClick={onTouchCard}>
        {children}
      </div>
    );
  }

  return (
    <a href={href} target='_blank' className={styles.jobCardLink}>
      {children}
    </a>
  );
};

export default LinkClient;
